import useVnvAssistEventHandlers from "./useVnvAssistEventHandlers";
import { useOwnChatStream } from "src/reusable/Chat/ChatStreaming/hooks/useOwnChatStream";
import { nuclearn_api_url } from "src/App";
import { ChatConfiguration } from "src/reusable/Chat/ChatStreaming/types";

export const useVnvAssistChat = (
  config?: Partial<ChatConfiguration>,
  dialogue?: any[],
) => {
  const { metadataHandler, messageHandler } = useVnvAssistEventHandlers();

  return useOwnChatStream(
    {
      api: `${nuclearn_api_url}/chat/converse`,
      onMetadataEvent: metadataHandler,
      onMessageEvent: messageHandler,
      ...config,
    },
    dialogue,
  );
};
